/**
 * Vault "For Sale" badge — only approved Active listings.
 * Under review / expired / removed / rejected must not show as for sale.
 */
export function isCollectibleListedForSale(item) {
    if (!item) return false;
    const status = item.marketplaceListingStatus;
    if (status && status !== 'Active') return false;
    return Boolean(item.isForSale);
}
